export enum EAddonListTabs {
	ADDON = 'addon',
	ADDON_MEAL = 'addon_meal',
}

export enum EAddonsDetailsTabs {
	GENERAL = 'general',
	INGRIDIENTS_AND_VARIANTS = 'ingridients_and_variants',
	REVIEWS = 'reviews',
	EDIT_HISTORY = 'edit_history',
}

export enum EAddonsDetailsIngredientsTabs {
	ALL = 'all',
	ADD_SIZE = 'add_size',
}

export enum EAddonsCategoryTypes {
	SUPPLEMENT = 'supplement',
	BEVERGE = 'beverage',
	OTHER = 'other',
	MEAL = 'meal',
	MEALPREP = 'prep_meal',
	SANDWICH = 'sandwich',
	COOKIE = 'cookie',
}

export enum EAddonsGeneralCategoryTypes {
	SUPPLEMENT = 'supplement',
	BEVERGE = 'beverage',
	OTHER = 'other',
}

export enum EAddonMealCategoryTypes {
	MEAL = 'meal',
	MEALPREP = 'prep_meal',
	SANDWICH = 'sandwich',
}

export enum EAddonCategoryMealTypes {
	MEAL = 'meal',
	SANDWICH = 'sandwich',
}

export const addonCatergoryTypesMap: { [key in EAddonsCategoryTypes]: string } = {
	[EAddonsCategoryTypes.SUPPLEMENT]: 'Suplement',
	[EAddonsCategoryTypes.BEVERGE]: 'Napój',
	[EAddonsCategoryTypes.OTHER]: 'Inny',
	[EAddonsCategoryTypes.MEAL]: 'Danie',
	[EAddonsCategoryTypes.MEALPREP]: 'Mealprep',
	[EAddonsCategoryTypes.SANDWICH]: 'Kanapka',
	[EAddonsCategoryTypes.COOKIE]: 'Ciastko',
}

export const addonCategoryTypes = generateSelectOptions(EAddonsCategoryTypes, addonCatergoryTypesMap)
